import React from 'react';

const fallbackMessage = 'Preparing your document...';

const ProcessingSpinner = ({
  stage,
  stageMessage,
  currentStep = 1,
  totalSteps = 8,
  isDark = false,
}) => {
  const normalizedStep = Math.max(1, Math.min(Number(currentStep) || 1, Number(totalSteps) || 8));
  const normalizedTotal = Math.max(1, Number(totalSteps) || 8);
  const progressPct = Math.round((normalizedStep / normalizedTotal) * 100);

  return (
    <div className="h-full w-full flex flex-col items-center justify-center px-6">
      <style>{`
        @keyframes ik-luma-spin-a {
          0% { transform: rotateX(65deg) rotateY(-15deg) rotateZ(0deg); }
          100% { transform: rotateX(65deg) rotateY(-15deg) rotateZ(360deg); }
        }
        @keyframes ik-luma-spin-b {
          0% { transform: rotateX(-60deg) rotateY(20deg) rotateZ(0deg); }
          100% { transform: rotateX(-60deg) rotateY(20deg) rotateZ(-360deg); }
        }
        @keyframes ik-luma-pulse {
          0%, 100% { opacity: 0.45; }
          50% { opacity: 0.95; }
        }
      `}</style>

      <div className="relative h-20 w-20">
        <div
          className="absolute inset-0 rounded-full border-[3px]"
          style={{
            borderColor: 'rgba(232, 122, 42, 0.2)',
            borderTopColor: '#E87A2A',
            animation: 'ik-luma-spin-a 1.1s linear infinite',
          }}
        />
        <div
          className="absolute inset-2 rounded-full border-[3px]"
          style={{
            borderColor: 'rgba(232, 122, 42, 0.2)',
            borderBottomColor: '#E87A2A',
            animation: 'ik-luma-spin-b 1.5s linear infinite',
          }}
        />
        <div
          className="absolute inset-5 rounded-full"
          style={{
            background:
              'radial-gradient(circle, rgba(232,122,42,0.28) 0%, rgba(232,122,42,0.05) 70%, transparent 100%)',
            animation: 'ik-luma-pulse 1.8s ease-in-out infinite',
          }}
        />
      </div>

      <p
        className="mt-6 text-sm text-center max-w-xl"
        style={{ color: isDark ? '#e5e5e5' : '#1a1a1a' }}
      >
        {stageMessage || fallbackMessage}
      </p>
      <p className="mt-2 text-xs text-slate-500 dark:text-neutral-400">
        Step {normalizedStep} of {normalizedTotal}
        {stage ? ` • ${String(stage).replace(/_/g, ' ')}` : ''}
      </p>

      <div className="mt-3 h-1.5 w-56 rounded-full bg-[rgba(232,122,42,0.2)] overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${progressPct}%`,
            background: '#E87A2A',
          }}
        />
      </div>
    </div>
  );
};

export default ProcessingSpinner;
